import script from "./NewMap.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMap.vue?vue&type=script&setup=true&lang=js"

import "./NewMap.vue?vue&type=style&index=0&id=76eb65a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76eb65a5"]])

export default __exports__